import { isValidCell, getResolution, cellToParent, latLngToCell, cellToLatLng, } from 'h3-js';
/** Check whether a string is a valid H3 cell index at any resolution. */
export const isValidH3Index = (hex) => {
    if (!hex || hex.length < 15)
        return false;
    try {
        return isValidCell(hex);
    }
    catch {
        return false;
    }
};
/** Return the resolution (0-15) of a valid H3 index. Throws if invalid. */
export const getH3Resolution = (hex) => {
    if (!isValidH3Index(hex)) {
        throw new Error(`Invalid H3 index: ${hex}`);
    }
    return getResolution(hex);
};
/** Return the parent cell at the given resolution. Throws if invalid or res > current. */
export const h3ToParent = (hex, targetResolution) => {
    const currentRes = getH3Resolution(hex);
    if (targetResolution > currentRes) {
        throw new Error(`Target resolution ${targetResolution} > current resolution ${currentRes}`);
    }
    if (targetResolution === currentRes)
        return hex;
    return cellToParent(hex, targetResolution);
};
/** Convert lat/lng to an H3 cell index at the given resolution. */
export const latLngToH3 = (lat, lng, resolution) => latLngToCell(lat, lng, resolution);
/** Return the [lat, lng] centroid of an H3 cell. */
export const h3ToLatLng = (hex) => {
    if (!isValidH3Index(hex)) {
        throw new Error(`Invalid H3 index: ${hex}`);
    }
    return cellToLatLng(hex);
};
/**
 * Convert an H3 hex ID to a human-readable location display object.
 * Includes lat/lng, a Google Maps link, and a display label (location name or hex ID).
 */
export const getHexLocationDisplay = (hexId, resolveLocation) => {
    const [lat, lng] = h3ToLatLng(hexId);
    const locationName = resolveLocation(hexId, h3ToParent);
    const mapsUrl = `https://www.google.com/maps?q=${lat.toFixed(5)},${lng.toFixed(5)}`;
    const displayLabel = locationName ?? hexId;
    return { lat, lng, locationName, mapsUrl, displayLabel };
};
/**
 * Return the full parent chain from res 0 through the hex's own resolution.
 * Index i in the returned array is the ancestor at resolution i.
 * Used by the GLS engine to query all resolution levels in parallel.
 */
export const getParentChain = (hex) => {
    const currentRes = getH3Resolution(hex);
    const chain = [];
    for (let res = 0; res <= currentRes; res++) {
        chain.push(res === currentRes ? hex : cellToParent(hex, res));
    }
    return chain;
};
//# sourceMappingURL=h3.js.map